<template>
	<v-container>
		<v-layout row wrap>
			<v-flex xs12>
				<v-card
					outlined
					flat
					width="100%"
					color="rgba(0, 0, 0, 0)"
				>
					<v-card-title primary-title>
						{{ title }}
					</v-card-title>
					<v-card-text>
						<v-form
							ref="form"
							v-model="dValid"
							:lazy-validation="lazy"
						>
							<slot v-bind:rules="mFormRules"></slot>
						</v-form>
					</v-card-text>
				
					<v-divider></v-divider>
					
					<v-card-actions>
						<v-spacer></v-spacer>
						<v-btn v-if="resetable" text color="warning" @click="reset()">{{ textCancel }}</v-btn>
						<v-btn text color="success" @click="validate()">{{ textOk }}</v-btn>
					</v-card-actions>
				</v-card>
			</v-flex>

			<v-snackbar
				v-model="snackbar"
				color="warning"
			>
				Informazioni mancanti o non corrette, controllare.
				<v-btn text color="primary" @click.native="snackbar = false">Close</v-btn>
			</v-snackbar>
		</v-layout>
	</v-container>
</template>

<script>
	import Asyncable from "@mixins/Asyncable";
	import Form from "@mixins/Form";

	export default {
		props: {
			lazy: {
				type: Boolean,
				default: false
			},

			textOk: {
				type: String,
				default: "Salva"
			},

			textCancel: {
				type: String,
				default: "Reset"
			},

			value: {
				type: Object,
				default: () => {}
			},

			title: {
				type: String,
				default: "Title"
			},

			api: {
				type: String,
				required: true
			},

			resetable: {
				type: Boolean,
				default: false
			}
		},

		mixins: [Asyncable, Form],

		data() {
			return {
				dValid: true,
				snackbar: false
			}
		},

		methods: {
			validate() {
				if(!this.$refs.form.validate()) {
					this.snackbar = true;
					return;
				}

				this.submit();
			},

			reset() {
				this.$refs.form.reset();
			},

			resetValidation() {
				this.$refs.form.resetValidation();
			}
		},

		asyncMethods: {
			submit() {
				return this.$agent.post(this.api, this.value)
					.then(response => {
						this.$emit("input", response);
						return response;
					});
			}
		},

		// mounted() {
		// 	// Check for all the input field marked as 'required' and make
		// 	// bind them to a default validation rule.

		// 	// Selects all the input and textarea contained into the main
		// 	// container of the default slot
		// 	this.$slots.default[0].elm.querySelectorAll("input,textarea").forEach(elem => {
		// 		console.log(elem);
		// 		if(elem.required) {
		// 			elem.rules = [(v) => { if(!v) return "Compilare il campo" }]
		// 			elem.class = "required"
		// 		}
		// 	});
		// }
	}
</script>